import { render, staticRenderFns } from "./stockAllocation.vue?vue&type=template&id=518f5a6c&scoped=true&"
import script from "./stockAllocation.vue?vue&type=script&lang=js&"
export * from "./stockAllocation.vue?vue&type=script&lang=js&"
import style0 from "./stockAllocation.vue?vue&type=style&index=0&id=518f5a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f5a6c",
  null
  
)

export default component.exports